<template>
    <div class="site-header">
        <div class="row container">
            <div class="col col-s8">XX Congresso Nazionale SIGU</div>
            <div class="col col-s4">

                <a href="http://www.sigu.net" target="blank">SIGU.NET</a>
                <router-link to="/inside/contatti/segreteria-organizzativa">CONTATTI</router-link>
                <router-link to="/home">HOME</router-link>
                
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'site-header',
  components: {
  }
}
</script>
<style>
.site-header{
    background: #F67711;
    height: 41px;
    border-bottom:1px solid black;
    color:#ffffff;
    line-height: 36px;
    font-size: 1.8rem;
}.site-header a{
    color:#ffffff;
    line-height: 1.6rem;
    font-size: 1.6rem;
    float:right;
    padding: 0 20px;
    margin:10px 0 0 0;
    border-left:1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// Site-header.vue?1cac6859